<template>
  <header>

    <div class="headline uk-container uk-container-xsmall uk-container-center">

      <img
        src="../assets/logo.png"
        alt="WebMo Logo"
        class="logoimg"
      />
      <h1>Welcome to WebMo</h1>
      <h3>Your WebMo will be available in a few moments</h3>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header'
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  margin: 0 0 1rem;
  text-align: center;
}

.logo {
  padding: 10px 0 0 10px;
  text-align: left;
  background: #fff;
}

.logo img {
  height: 50px;
  width: auto;
}
.logoimg {
  height: 50px;
  width: auto;
}

.headline {
  margin-top: 2rem;
}
</style>
